<div class="board" [class.margin]="margin">
  <span class="title">{{ title }}</span>
  <span class="score" [ngClass]="state ? state : ''">
    <ng-content></ng-content>
  </span>
</div>
